module.exports = __webpack_public_path__ + "img/filter.e85b49ba.svg";